import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionHeadingProps {
    eyebrow?: string
    title: ReactNode
    description?: ReactNode
    align?: 'left' | 'center'
    tone?: 'default' | 'inverted'
    headingId?: string
    className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    description,
    align = 'left',
    tone = 'default',
    headingId,
    className
}): ReactNode => {
    const inverted = tone === 'inverted'

    return (
        <div className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center', className)}>
            {eyebrow && (
                <p className={cn('text-xs font-semibold uppercase tracking-[0.18em]', inverted ? 'text-brand' : 'text-brand-strong')}>
                    {eyebrow}
                </p>
            )}

            <h2 id={headingId} className={cn('mt-3 text-balance font-heading text-3xl font-semibold tracking-tight sm:text-4xl', inverted ? 'text-ink-foreground' : 'text-foreground')}>
                {title}
            </h2>

            {description && (
                <p className={cn('mt-4 text-pretty text-base leading-relaxed sm:text-lg', inverted ? 'text-ink-muted' : 'text-muted-foreground')}>
                    {description}
                </p>
            )}
        </div>
    )
}
